import { IAudience } from "../../../sponsoredProductsSKCAntd/types/audience"

export interface ISbAudienceOption {
  label: string
  value: string
}

export function buildAudienceOptions(audiences: IAudience[]): ISbAudienceOption[] {
  const optionsById = new Map<string, ISbAudienceOption>()

  for (const audience of audiences) {
    if (!optionsById.has(audience.audienceId)) {
      optionsById.set(audience.audienceId, {
        label: audience.audienceResolved,
        value: audience.audienceId,
      })
    }
  }

  return [...optionsById.values()]
}
